import script from "./About.vue?vue&type=script&lang=ts&setup=true"
export * from "./About.vue?vue&type=script&lang=ts&setup=true"

import "./About.vue?vue&type=style&index=0&id=d4d32b18&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4d32b18"]])

export default __exports__